// components/ResetAnimationModal.js
import { __ } from '@wordpress/i18n';
import { Button, Modal } from '@wordpress/components';
import { useState } from '@wordpress/element';

/**
 * A reusable confirmation modal for resetting animation attributes.
 *
 * @param {Object} props
 * @param {Function} props.onConfirm - Called when the user confirms reset.
 */
export default function ResetAttributes({ onConfirm }) {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                variant="secondary"
                onClick={() => setShowModal(true)}
            >
                {__('Reset', 'aver')}
            </Button>

            {showModal && (
                <Modal
                    title={__('Reset', 'aver')}
                    onRequestClose={() => setShowModal(false)}
                >
                    <p>
                        {__('Are you sure you want to reset?', 'aver')}
                    </p>

                    <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                        <Button
                            variant="primary"
                            onClick={() => {
                                onConfirm();
                                setShowModal(false);
                            }}
                        >
                            {__('Yes, reset', 'aver')}
                        </Button>

                        <Button
                            variant="secondary"
                            onClick={() => setShowModal(false)}
                        >
                            {__('Cancel', 'aver')}
                        </Button>
                    </div>
                </Modal>
            )}
        </>
    );
}
